import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import { useTranslate } from "src/locales";
import { FORM_STYLES } from "../constants";
import { PageOneFormData } from "../models";

export const IdentifyingPersons = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageOneFormData>();

  return (
    <Grid md={8} xs={12} spacing={2} sx={{ padding: "0px" }}>
      <Box
        sx={{
          border: FORM_STYLES.sectionBorder,
          borderRadius: FORM_STYLES.sectionBorderRadius,
          padding: FORM_STYLES.sectionPadding,
          height: "100%",
        }}
      >
        <Grid
          sx={{
            backgroundColor: FORM_STYLES.titleBackgroundColor,
            color: FORM_STYLES.titleColor,
            borderRadius: FORM_STYLES.titleBorderRadius,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
            {t("adult-patient-assessment.identifying-persons")}
          </ByzMuiTypography>
          <ByzGrdDeleteButton />
        </Grid>
        <Stack direction={"row"}>
          {/* Column 1 */}
          <Grid md={4} xs={6}>
            <Grid sx={{ paddingTop: "10px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.degree-of-relationship")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.relationship"
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect
                    {...field}
                    renderInput={(params) => <ByzMuiTextField {...params} />}
                    options={[]}
                    label={t("open-process-menu.select", "capitalize")}
                    placeholder={t("open-process-menu.select", "capitalize")}
                    sx={{ width: "100%", maxWidth: "300px" }}
                  />
                )}
              />
            </Grid>
            <Grid sx={{ paddingTop: "20px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.surname")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.surname"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <ByzMuiTextField
                    {...field}
                    sx={{ width: "100%", maxWidth: "300px" }}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
            <Grid sx={{ paddingTop: "20px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.home-phone")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.homePhone"
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} sx={{ width: "100%", maxWidth: "300px" }} />
                )}
              />
            </Grid>
          </Grid>

          {/* Column 2 */}
          <Grid md={4} xs={6}>
            <Grid sx={{ paddingTop: "10px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.person-status")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.personStatus"
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect
                    {...field}
                    renderInput={(params) => <ByzMuiTextField {...params} />}
                    options={[]}
                    label={t("open-process-menu.select", "capitalize")}
                    placeholder={t("open-process-menu.select", "capitalize")}
                    sx={{ width: "100%", maxWidth: "300px" }}
                  />
                )}
              />
            </Grid>
            <Grid sx={{ paddingTop: "20px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.mobile-phone")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.mobilePhone"
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} sx={{ width: "100%", maxWidth: "300px" }} />
                )}
              />
            </Grid>
          </Grid>

          {/* Column 3 */}
          <Grid md={4} xs={6}>
            <Grid sx={{ paddingTop: "10px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.name")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.name"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <ByzMuiTextField
                    {...field}
                    sx={{ width: "100%", maxWidth: "300px" }}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
            <Grid sx={{ paddingTop: "20px" }}>
              <ByzMuiTypography fontWeight={400} marginLeft="0" textAlign="left">
                {t("adult-patient-assessment.work-phone")}
              </ByzMuiTypography>
            </Grid>
            <Grid sx={{ paddingTop: "5px" }}>
              <Controller
                name="identifyingPersons.workPhone"
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} sx={{ width: "100%", maxWidth: "300px" }} />
                )}
              />
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Grid>
  );
};
